import { ExplainerLayout } from '@/components/ExplainerLayout';
import { KOD_PKD } from '@/content/przewodniki';

const KodPkdJakWybrac = () => <ExplainerLayout guide={KOD_PKD} />;

export default KodPkdJakWybrac;
